import { useContext } from "react";
import { UserPageContext } from "../contexts/userPageContext";

const useUserPageContext = () => useContext(UserPageContext);

export { useUserPageContext };
